/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { useMutation } from 'react-query'

import { extendTrialAdminV1 } from '@modules/billing-api/v1/callers'
import type { QueryFunctionReturnType } from '@modules/query/types'

const useExtendTrialAdmin = () =>
  useMutation<
    QueryFunctionReturnType<typeof extendTrialAdminV1>,
    unknown,
    { organizationId: string; expiration: string }
  >({
    mutationFn: ({ organizationId, expiration }) =>
      extendTrialAdminV1({
        pathParameters: { organization_id: organizationId },
        queryParameters: { expiration },
      }),
  })

export default useExtendTrialAdmin
